import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Check2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <rect x="1.75" y="1.75" width="28.5" height="28.5" rx="8.25" fill="#181818" />
      <rect
        x="1.75"
        y="1.75"
        width="28.5"
        height="28.5"
        rx="8.25"
        fill="url(#paint0_linear_129_554)"
        fillOpacity="0.2"
      />
      <rect
        x="1.75"
        y="1.75"
        width="28.5"
        height="28.5"
        rx="8.25"
        stroke="url(#paint1_linear_129_554)"
        strokeWidth="1.5"
      />
      <rect x="8.5" y="8" width="15" height="15" rx="4.5" fill="url(#paint2_linear_129_554)" />
      <rect x="8.5" y="8" width="15" height="15" rx="4.5" fill="#84FF97" />
      <defs>
        <linearGradient
          id="paint0_linear_129_554"
          x1="1"
          y1="16"
          x2="31"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#368D44" />
          <stop offset="1" stopColor="#21652C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_129_554"
          x1="1"
          y1="16"
          x2="31"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#368D44" />
          <stop offset="1" stopColor="#21652C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_129_554"
          x1="8.5"
          y1="15.5"
          x2="23.5"
          y2="15.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E63F3F" />
          <stop offset="1" stopColor="#AB2929" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
